import { css } from '@repo/pandacss/styled-system/css';
import { renderStructuredContent } from '../../rendererContext';
import { LiProps } from './types';

export function Li({ props: { children, rendererProps } }: LiProps) {
  return (
    <li
      className={css({
        display: 'flex',
        _before: {
          content: '"\\2022"',
          pr: '4',
        },
        '&:not(:last-child)': { marginBottom: '1' },
      })}
    >
      {renderStructuredContent(children, rendererProps)}
    </li>
  );
}
